var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.cstore.getShip.wait
        ? _c(
            "div",
            { staticClass: "CruisePage__ifloader" },
            [_c(_setup.Loader, { staticClass: "CruisePage__loader" })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.cstore.getShip.ok
        ? [
            _c(_setup.Ship, {
              attrs: {
                ship: _setup.cstore.getShip.resolve.ship,
                roomDetail: _setup.cstore.getShip.resolve.roomDetail,
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _setup.cstore.getShip.reject
        ? _c("div", [_vm._v("! не удалось")])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }